module.exports = __webpack_public_path__ + "img/park-list-cover-1.3d4ce419.png";